import { render, staticRenderFns } from "./Stadium.vue?vue&type=template&id=0b5fe411"
import script from "./Stadium.vue?vue&type=script&lang=ts"
export * from "./Stadium.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports